export const ADMIN_USERS_NOTICE_KEY = "lotlocator-admin-users-notice";

export type AdminUsersNotice = {
  type: "success" | "error";
  message: string;
};
